module.exports = __webpack_public_path__ + "static/media/Galvantula_gaussian2.7ef5e1fa.png";